<div class="user-settings-container">
	<div class="heading">
		<app-page-title title="User Settings"></app-page-title>
		<app-step-navigator [stepConfig]="stepConfig"></app-step-navigator>
	</div>
	<div class="content">
		<router-outlet></router-outlet>
	</div>
</div>
